import YHtance from "./request";
export const getRegConfig = (params) => YHtance.post("/admin/getRegConfig", params);
export const getcomInfo = (params) => YHtance.post("/admin/getcomInfo", params);
export const getresInfo = (params) => YHtance.post("/admin/getresInfo", params);
export const setresInfo = (params) => YHtance.post("/admin/setresInfo", params);
export const setregister = (params) => YHtance.post("/admin/setregister", params);